import React from "react";
import {Link} from 'react-router';
import MdField from "core/metamodel/mdField";
import MdEntity from "core/metamodel/mdEntity";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import {isArrayLike, ObservableMap} from "mobx";
import {FieldObjectType} from "core/form/form";
import {formatValue} from "core/form/formUtils";
import {addTenantToQuery} from "core/common/utils/utils";

import "core/form/closedForm.less";

export interface ClosedFormFieldProps {
  label?: string;
  value?: any;
  mdField?: MdField;
  linkProps?: any;
  style?: React.CSSProperties;
  alwaysShow?: boolean;
  children?: Array<React.ReactChild> | React.ReactChild;
}

export interface ClosedFormBlockProps<D extends DomainAncestor> {
  dataObject: D;
  rootObject?: any;
  entities: ObservableMap<MdEntity>;
  entity: MdEntity;
  disabled?: boolean;
  style?: React.CSSProperties;
  alwaysShow?: boolean;
  fields: { [key in keyof D]: FieldObjectType };
  children?: Array<React.ReactChild> | React.ReactChild;
  singleColumn?: boolean;
}

export const ClosedFormField: React.SFC<ClosedFormFieldProps> = ({label, value, mdField, linkProps, style, alwaysShow, children}: ClosedFormFieldProps) => {

  let childrenCount = React.Children.count(children);

  return (
    (childrenCount == 0) ? (
      (linkProps) ? (
        <Link {...linkProps} style={style} query={addTenantToQuery(linkProps.query)}>
          <div className="value-label">{ isArrayLike(value) ? value.map(v => formatValue(v, mdField)).join(', ') : formatValue(value, mdField)}</div>
        </Link>
        ) : (
        <div className="value-label">{isArrayLike(value) ? value.map(v => formatValue(v, mdField)).join(', ') : formatValue(value, mdField)}</div>
      )
    ) : (
      (childrenCount == 1) ? (
        React.Children.only(children)
      ) : (
        <div className="value-label">{children}</div>
      )
    )
  );
};


export const ClosedFormBlock = <D extends DomainAncestor>({dataObject, entity, entities, fields, disabled, alwaysShow,singleColumn, children}: ClosedFormBlockProps<D>) => {


  // hack na dva sloupce - cekame na subgridy
  let childrenArray = React.Children.toArray(children);
  let biggerHalf = (singleColumn) ? childrenArray.length : Math.ceil(childrenArray.length / 2);
  let gridItems1 = [];
  let gridItems2 = [];

  React.Children.forEach(children, (child: React.ReactElement<ClosedFormFieldProps>, index: number) => {
    if (child && (child.props.value != null || alwaysShow || child.props.alwaysShow || React.Children.count(child.props.children) > 0)) {
      let _gi = (index < biggerHalf) ? gridItems1 : gridItems2;
      _gi.push((React.isValidElement(child.props.label)) ? child.props.label :
        <div className="item-label" key={index}>{child.props.label}:</div>);
      _gi.push(child);
    }
  });

  return (

    <div className="form-closed-gridgroup">
      <div className="form-closed-grid">
        {[...gridItems1]}
      </div>
      { (!singleColumn) ? (
        <div className="form-closed-grid">
          {[...gridItems2]}
        </div>
      ) : null}
    </div>

  )
};



// WEBPACK FOOTER //
// ./src/core/form/closedForm.tsx